import React, {
    memo, 
    useEffect, 
    useState, 
    // useLayoutEffect 
} from 'react'
import PropTypes from 'prop-types'
import ReactPaginate from 'react-paginate'

// hooks
import useWindowSize from './../../../Hooks/useWindowSize'

// Set number page count
export const setNumberPages = (items, perPage) => {
    return items.length / perPage
}

//Primer item a mostar en la página actual
export const calculateInitElementShow = (offset, perPage) => {
    const result = offset  * perPage 
    return result
}

//indice del último item a mostar en la página actual
export const calculateFnElementShow = (offset, perPage ) =>(
    calculateInitElementShow(offset, perPage ) + perPage
)

const FirstPage = (props)=>{

    const {
        onClick
    } = props

    const {
        width: widthWindow,
    } = useWindowSize()

    if(widthWindow <= 960){
        return(
            <div 
                className='paginationMolFirst'
                onClick={onClick}
            >
                <span className='icon icon-arrow-left'></span>
            </div>
        )
    }else {
        return(
            <div 
                className='paginationMolFirst'
                onClick={onClick}
            >
                Primera
            </div>
        )
    }

}

const LastPage = (props)=>{

    const {
        onClick,
    } = props

    const {
        width: widthWindow,
    } = useWindowSize()

    if(widthWindow <= 960){
        return(
            <div 
                className='paginationMolLast'
                onClick={onClick}
            >
                <span className='icon icon-arrow-right'></span>
            </div>
        )
    }else {
        return(
            <div 
                className='paginationMolLast'
                onClick={onClick}
            >
                Última
            </div>
        )
    }

}
const PrevPage = (props)=>{

    const {previousLabel, onClick} = props

    const {
        width: widthWindow,
    } = useWindowSize()

    if(widthWindow <= 960){
        return(<div onClick={onClick} className='paginationMolPrevCont'> Anterior</div>)
    }else {
        return(<div onClick={onClick} className='paginationMolPrevCont'> {previousLabel}<span className='icon icon-angle-left'></span></div>)
    }

}

const NextPage = (props)=>{

    const {nextLabel, onClick} = props

    const {
        width: widthWindow,
    } = useWindowSize()

    if(widthWindow <= 960){
        return(<div onClick={onClick} className='paginationMolNextCont'> Siguiente</div>)
    }else {
        return(<div onClick={onClick} className='paginationMolNextCont'> {nextLabel}<span className='icon icon-angle-right'></span></div>)
    }
}
const BreakPage = (props)=>{

    const {breakLabel} = props

    const {
        width: widthWindow,
    } = useWindowSize()

    if(widthWindow <= 960){
        return(<></>)
    }else {
        return(<>{breakLabel} </>)
    }
}

const PaginationComponent = (props) => {
    const {
        pageCount,
        // initialPage,
        previousLabel,
        nextLabel,
        onClickPrevious,
        onClickNext,
        breakLabel,
        marginPagesDisplayed,
        pageRangeDisplayed,
        onPageChange,
        forcePage,

        containerClassName,
        subContainerClassName,
        breakClassName,
        activeClassName,
        pageClassName,
        previousClassName,
        nextClassName,
        activeLinkClassName,

    } = props

    const [ pageRangeDisplayedState, setPageRangeDisplayedState ] = useState(false)

    const [pageNow, setPageNow] = useState(false)

    const {
        width: widthWindow,
    } = useWindowSize()

    useEffect(()=>{
        if(widthWindow <= 960){
            setPageRangeDisplayedState(1)
        }else {
            setPageRangeDisplayedState(false)
        }
    },[widthWindow])

    const changePageNow = (page) => {
        onPageChange({ selected: page})
        setPageNow(page)    
    }
    console.log("forcePage", forcePage, pageNow)
    return (
        <div className='paginationMolMain'>
            {/* {'last:' + lastPage +  'first:' + firstPage + forcePage} */}

            <FirstPage onClick={()=>changePageNow(0)} />

            <ReactPaginate
                pageCount={pageCount}
                // initialPage ={initialPage}
                previousLabel={<PrevPage previousLabel={previousLabel} onClick={onClickPrevious}/>}
                nextLabel={<NextPage nextLabel={nextLabel} onClick={onClickNext}/>}
                breakLabel={<BreakPage breakLabel={breakLabel}/>}
                marginPagesDisplayed={ marginPagesDisplayed}
                pageRangeDisplayed={pageRangeDisplayedState || pageRangeDisplayed}
                onPageChange={(d)=>{setPageNow(d.selected); onPageChange(d);}}
                forcePage={forcePage}
                
                containerClassName={`paginationMol ${containerClassName}`}
                subContainerClassName={`paginationMolSub ${subContainerClassName}`}
                pageClassName={`paginationMolPage ${pageClassName}`}
                previousClassName={`paginationMolPrev ${previousClassName}`}
                nextClassName={`paginationMolNext ${nextClassName}`}
                activeClassName={`paginationMolActive ${activeClassName}`}
                activeLinkClassName={`paginationMolActiveLink ${activeLinkClassName}`}
                breakClassName={`paginationMolBreak ${breakClassName}`}

            />
            <LastPage
                onClick={()=>changePageNow(pageCount - 1)}
            />
           
        </div>
    )
}

PaginationComponent.propTypes = {
    breakLabel: PropTypes.string,
    forcePage: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.bool,
    ]),
    initialPage: PropTypes.number,
    marginPagesDisplayed: PropTypes.number,
    // previousLabel: PropTypes.string,
    // nextLabel: PropTypes.string,
    onPageChange: PropTypes.func.isRequired,
    pageCount: PropTypes.number.isRequired,
    pageRangeDisplayed: PropTypes.number,

    containerClassName: PropTypes.string,
    subContainerClassName: PropTypes.string,
    breakClassName: PropTypes.string,
    activeClassName: PropTypes.string,

    pageClassName: PropTypes.string,
    previousClassName: PropTypes.string,
    nextClassName: PropTypes.string,
    activeLinkClassName: PropTypes.string
}

PaginationComponent.defaultProps = {
    // pageCount: 10,
    initialPage: 0,
    previousLabel: '',
    nextLabel: '',
    breakLabel: '...',
    onClickPrevious: ()=> console.log('prev'),
    onClickNext: ()=> console.log('next'),

    marginPagesDisplayed: 1,
    pageRangeDisplayed: 3,
    onPageChange: ()=>{},
    
    containerClassName:'',
    subContainerClassName:'',
    breakClassName: '',
    activeClassName:'',
    // forcePage: null,
}

export default memo(PaginationComponent)
